document.addEventListener("DOMContentLoaded", () => {
  const sidebar = document.getElementById("sidebar");
  const btns = document.querySelectorAll("[data-action='toggle-sidebar']");
  const layer40 = document.getElementById("layer-40");

  if (sidebar && btns && layer40) {
    btns.forEach((item) => {
      item.addEventListener("click", () => {
        sidebar.classList.toggle("translate-x-full");
        layer40.classList.toggle("hidden");
        document.body.classList.toggle("h-screen");
        document.body.classList.toggle("overflow-hidden");
      });
    });
  }
});

export const showSidebar = () => {
  const sidebar = document.getElementById("sidebar");
  const btns = document.querySelectorAll("[data-action='toggle-sidebar']");
  const layer40 = document.getElementById("layer-40");

  if (sidebar && btns && layer40) {
    sidebar.classList.toggle("translate-x-full");
    layer40.classList.toggle("hidden");
    document.body.classList.toggle("h-screen");
    document.body.classList.toggle("overflow-hidden");
  }
};
